module.exports = __webpack_public_path__ + "949f4607359faed05cd9702420206ec8.png";